export let caseSpecs = [
  {
    label: 'ID',
    item_key: 'id',
    value: ''
  },
  {
    label: 'Case id',
    item_key: 'caseNumber',
    value: ''
  },
  {
    label: 'Case id',
    item_key: 'caseLink',
    value: {
      url: { link: { name: 'CaseView', params: { caseId: '' } } }
    },
    title_key: 'caseNumber',
    component: 'LinkComponent',
    sort_key: 'case_id'
  },
  {
    label: 'State',
    item_key: 'state',
    value: { display: '', level: 0 },
    component: 'StatusComponent',
    sort_key: 'state',
    filter: 'state'
  },
  {
    label: 'State',
    item_key: 'stateCell',
    value: { display: '', level: 0 },
    component: 'StatusCellComponent'
  },
  {
    label: 'Date created',
    item_key: 'applicationDate',
    value: ''
  },
  {
    label: 'Signee name',
    item_key: 'signature.name',
    value: ''
  },
  {
    label: 'Signee pnr',
    item_key: 'signature.pnr',
    value: ''
  },
  {
    label: 'Ip address',
    item_key: 'signature.ipAddress',
    value: ''
  },
  {
    label: 'Signature date',
    item_key: 'signature.signedAt',
    value: ''
  },
  {
    label: 'Created',
    item_key: 'created',
    value: '',
    sort_key: 'created',
    width: 140,
    filter: 'date_created'
  },
  {
    label: 'Case type',
    item_key: 'caseType.display',
    value: '',
    sort_key: 'case_type',
    filter: 'case_type'
  },
  {
    label: 'Current certificate authority',
    item_key: 'currentCa',
    value: ''
  },
  {
    label: 'Current certificate number',
    item_key: 'currentCertificateNumber',
    value: ''
  },
  {
    label: 'Certification',
    item_key: 'service.code',
    value: '',
    sort_key: 'service_code',
    filter: 'service'
  },
  {
    label: 'Certification',
    item_key: 'service.shortName',
    value: '',
    sort_key: 'service_code',
    filter: 'service'
  },
  {
    label: 'Qualification',
    item_key: 'qualification.value',
    value: ''
  },
  {
    label: 'Qualification',
    item_key: 'qualification.display',
    value: ''
  },
  {
    label: 'Boverket list',
    item_key: 'getBoverket',
    value: ''
  },
  {
    label: 'Exam selection',
    item_key: 'examSelection.display',
    value: ''
  },
  {
    label: 'Exam date',
    item_key: 'examDate.value',
    value: ''
  },
  {
    label: 'Exam dates',
    item_key: 'examDates.value',
    value: ''
  },
  {
    label: 'Want ID06 card printed',
    item_key: 'wantIdCard',
    value: { display: '', level: 0 },
    component: 'StatusCellComponent'
  },
  {
    label: 'Member of SBR',
    item_key: 'memberOfSbr',
    value: { display: '', level: 0 },
    component: 'StatusCellComponent'
  },
  {
    label: 'Want to be listed at Boverket',
    item_key: 'boverket.value',
    value: ''
  },
  {
    label: 'Reviewer',
    item_key: 'reviewer.name',
    value: '',
    sort_key: 'reviewer_first_name,reviewer_last_name',
    filter: 'reviewer',
    width: 150
  },
  {
    label: 'Requested auditor',
    item_key: 'requestedAuditor.name',
    value: ''
  },
  {
    label: 'Updated',
    item_key: 'modified',
    value: '',
    sort_key: 'modified'
  },
  {
    label: 'Customer name',
    item_key: 'customer.fullName',
    value: '',
    sort_key: 'first_name,last_name',
    width: 200
  },
  {
    label: 'Responsible',
    item_key: 'responsible.profileTypeDisplay',
    value: '',
    sort_key: 'responsible',
    filter: 'responsible'
  },
  {
    label: 'Progress',
    item_key: 'progress',
    value: '',
    component: 'ProgressBarComponent'
  },
  {
    label: 'Documents',
    item_key: 'documentsTable',
    value: [],
    component: 'DocumentsTableComponent'
  },
  {
    label: 'Controller',
    item_key: 'controller.name',
    value: ''
  },
  {
    label: 'Invoiced',
    item_key: 'invoiceState',
    value: { display: '', level: 0 },
    component: 'StatusComponent',
    sort_key: 'has_invoice',
    filter: 'has_invoice'
  },
  {
    label: 'Invoiced',
    item_key: 'invoiceCell',
    value: { display: '', level: 0 },
    component: 'StatusCellComponent'
  },
  {
    label: 'Certificate number',
    item_key: 'certificate.certificateNumber',
    value: ''
  },
  {
    label: 'Certificate number',
    item_key: 'reviewCertificateLink',
    value: {},
    title_key: 'certificateNumber',
    component: 'LinkGridComponent'
  },
  {
    label: 'Is Certificate Reported',
    item_key: 'isCertificateReportedCell',
    value: { display: '', level: 0 },
    component: 'StatusCellComponent'
  }
]

export let auditorSpecs = [
  {
    label: 'Auditor',
    item_key: 'name',
    value: ''
  },
  {
    label: 'Reviewed cases',
    item_key: 'reviewedCases',
    value: ''
  },
  {
    label: 'Ongoing cases',
    item_key: 'ongoingCases',
    value: ''
  }
]

export let caseLogSpecs = [
  {
    label: 'Timestamp',
    item_key: 'timestamp',
    value: ''
  },
  {
    label: 'Change',
    item_key: 'content',
    value: ''
  },
  {
    label: 'Changed By',
    item_key: 'changedBy',
    value: ''
  }
]

export let customerLogSpecs = [
  {
    label: 'Timestamp',
    item_key: 'timestamp',
    value: ''
  },
  {
    label: 'Email sent',
    item_key: 'content',
    value: ''
  }
]

export let customerProfileSpecs = [
  {
    label: 'Personal ID',
    item_key: 'personNumber',
    value: '',
    sort_key: 'person_number'
  },
  {
    label: 'First name',
    item_key: 'firstName',
    value: ''
  },
  {
    label: 'Last name',
    item_key: 'lastName',
    value: ''
  },
  {
    label: 'Customer link',
    item_key: 'customerLink',
    value: {
      url: { name: 'InvoicingView', params: { customerId: '' } }
    },
    title_key: 'customerId',
    component: 'LinkComponent',
    sort_key: 'customer_id'
  },
  {
    label: 'Name',
    item_key: 'fullName',
    value: '',
    sort_key: 'first_name,last_name'
  },
  {
    label: 'Customer No.',
    item_key: 'customerId',
    value: ''
  },
  {
    label: 'Phone number',
    item_key: 'phoneNumber',
    value: ''
  },
  {
    label: 'Mobile number',
    item_key: 'mobileNumber',
    value: ''
  },
  {
    label: 'E-mail',
    item_key: 'email',
    value: '',
    sort_key: 'email'
  },
  {
    label: 'Alternate e-mail',
    item_key: 'alternateEmail',
    value: '',
    sort_key: 'alternateEmail'
  },
  {
    label: 'Website',
    item_key: 'website',
    value: ''
  },
  {
    label: 'Postal address',
    item_key: 'postalAddress',
    value: ''
  },
  {
    label: 'Postal code',
    item_key: 'postalCode',
    value: ''
  },
  {
    label: 'City',
    item_key: 'city',
    value: '',
    sort_key: 'city'
  },
  {
    label: 'Updated',
    item_key: 'modified',
    value: '',
    sort_key: 'modified'
  },
  {
    label: 'Public certificates',
    item_key: 'publicCertificatesCell',
    value: { display: '', level: 0 },
    component: 'StatusCellComponent'
  }
]

export let defaultCustomerKeys = ['firstName', 'lastName', 'personNumber', 'customerId', 'phoneNumber', 'mobileNumber', 'email', 'alternateEmail', 'website', 'postalAddress', 'postalCode', 'city', 'publicCertificatesCell']

export let invoiceCustomerSpecs = [
  {
    label: 'Org. number',
    item_key: 'orgNumber',
    value: '',
    sort_key: 'org_number'
  },
  {
    label: 'Company name',
    item_key: 'companyName',
    value: '',
    sort_key: 'company_name'
  },
  {
    label: 'Customer name',
    item_key: 'customerName',
    value: '',
    sort_key: 'customer_name'
  },
  {
    label: 'VAT',
    item_key: 'vatNumber',
    value: '',
    sort_key: 'vatNumber'
  },
  {
    label: 'Invoice customer link',
    item_key: 'invoiceCustomerLink',
    value: '',
    title_key: 'orgNumber',
    component: 'LinkComponent',
    sort_key: 'id'
  },
  {
    label: 'Email for invoices',
    item_key: 'email',
    value: '',
    sort_key: 'email'
  },
  {
    label: 'GLN',
    item_key: 'gln',
    value: '',
    sort_key: 'gln'
  },
  {
    label: 'Invoice distribution',
    item_key: 'distribution',
    value: '',
    sort_key: 'distribution'
  },
  {
    label: 'Invoice reference',
    item_key: 'reference',
    value: '',
    sort_key: 'reference'
  },
  {
    label: 'Invoice marking',
    item_key: 'marking',
    value: '',
    sort_key: 'marking'
  },
  {
    label: 'Phone',
    item_key: 'phone',
    value: '',
    sort_key: 'phone'
  },
  {
    label: 'Customer ID',
    item_key: 'customerId',
    value: '',
    sort_key: 'customerId'
  },
  {
    label: 'Invoice address',
    item_key: 'fullAddress',
    value: '',
    sort_key: 'fullAddress'
  },
  {
    label: 'Postal address',
    item_key: 'postalAddress',
    value: '',
    sort_key: 'postal_address'
  },
  {
    label: 'Postal city',
    item_key: 'postalCity',
    value: '',
    sort_key: 'postal_city'
  },
  {
    label: 'Postal code',
    item_key: 'postalCode',
    value: '',
    sort_key: 'postal_code'
  },
  {
    label: 'Use company address',
    item_key: 'useCompanyAddress',
    value: '',
    sort_key: 'use_company_address'
  },
  {
    label: 'Invoice customer id',
    item_key: 'invoiceCustomerId',
    value: '',
    sort_key: 'invoice_customer_id'
  }
]

export let cardOrderSpecs = [
  {
    label: 'Id',
    item_key: 'id',
    value: '',
    sort_key: 'id'
  },
  {
    label: 'Customer name',
    item_key: 'customer.fullName',
    value: '',
    sort_key: 'first_name,last_name'
  },
  {
    label: 'Certificate number',
    item_key: 'certificate.certificateNumber',
    value: '',
    sort_key: 'certificate_number'
  },
  {
    label: 'Certificate service',
    item_key: 'certificate.service.name',
    value: '',
    sort_key: 'service_name'
  },
  {
    label: 'Created',
    item_key: 'created',
    value: '',
    sort_key: 'created'
  },
  {
    label: 'Status',
    item_key: 'status',
    value: '',
    sort_key: 'status'
  }
]

export let invoiceSpecs = [
  {
    label: 'Invoice number',
    item_key: 'invoiceNumber',
    value: '',
    sort_key: 'invoice_number'
  },
  {
    label: 'Invoice No.',
    item_key: 'invoiceLink',
    value: {
      url: { name: 'InvoiceDetailsView', params: { invoiceId: '' } }
    },
    title_key: 'invoiceNumber',
    component: 'LinkComponent',
    sort_key: 'invoice_number'
  },
  {
    label: 'Created',
    item_key: 'created',
    value: '',
    sort_key: 'created',
    filter: 'date_created'
  },
  {
    item_key: 'totalSum',
    value: '',
    sort_key: 'total_sum'
  },
  {
    label: 'Customer name',
    item_key: 'customerName',
    value: '',
    sort_key: 'first_name,last_name'
  },
  {
    label: 'KIWA reference',
    item_key: 'kiwaReference',
    value: '',
    sort_key: 'kiwa_reference'
  },
  {
    label: 'Invoice reference',
    item_key: 'customerReference',
    value: '',
    sort_key: 'customer_eference'
  },
  {
    label: 'Invoice marking',
    item_key: 'marking',
    value: '',
    sort_key: 'marking'
  },
  {
    label: 'Updated at',
    item_key: 'modified',
    value: '',
    sort_key: 'modified'
  },
  {
    label: 'State',
    item_key: 'stateCell',
    value: { display: '', level: 0 },
    component: 'StatusCellComponent'
  },
  {
    label: 'State',
    item_key: 'state',
    value: { display: '', level: 0 },
    component: 'StatusComponent',
    sort_key: 'state',
    filter: 'state'
  },
  {
    item_key: 'markingField',
    value: { field: {}, formData: [] },
    component: 'FormFieldComponent'
  },
  {
    item_key: 'kiwaReferenceField',
    value: { field: {}, formData: [] },
    component: 'FormFieldComponent'
  },
  {
    item_key: 'customerReferenceField',
    value: { field: {}, formData: [] },
    component: 'FormFieldComponent'
  },
  {
    label: 'Case id',
    item_key: 'caseId',
    value: '',
    sort_key: 'case_id'
  },
  {
    label: 'Invoice customer',
    item_key: 'invoiceCustomer',
    value: '',
    sort_key: 'invoice_customer'
  }
]

export let invoiceArticleSpecs = [
  {
    item_key: 'number',
    value: '',
    sort_key: 'number'
  },
  {
    item_key: 'description',
    value: '',
    sort_key: 'description'
  },
  {
    item_key: 'price',
    value: '',
    sort_key: 'price'
  },
  {
    item_key: 'quantity',
    value: '',
    sort_key: 'quantity'
  },
  {
    item_key: 'sum',
    value: '',
    sort_key: 'sum',
    width: '15%',
    classes: 'has-text-right'
  },
  {
    label: 'State',
    item_key: 'state',
    value: { display: '', level: 0 },
    component: 'StatusComponent',
    sort_key: 'state'
  },
  {
    item_key: 'numberField',
    value: { field: {}, formData: [] },
    component: 'FormFieldComponent',
    width: '10%'
  },
  {
    item_key: 'descriptionField',
    value: { field: {}, formData: [] },
    component: 'FormFieldComponent',
    width: '50%'
  },
  {
    item_key: 'priceField',
    value: { field: {}, formData: [] },
    component: 'FormFieldComponent',
    width: '10%'
  },
  {
    item_key: 'quantityField',
    value: { field: {}, formData: [] },
    component: 'FormFieldComponent',
    width: '10%'
  },
  {
    item_key: 'button',
    value: { text: '', clickHandler: () => {} },
    component: 'ButtonComponent',
    width: '5%'
  }
]

export let reviewResultSpecs = [
  {
    label: 'First name',
    component: 'REVIEW',
    item_key: 'name',
    value: ''
  },
  {
    label: 'Last name',
    component: 'REVIEW',
    item_key: 'last-name',
    value: ''
  },
  {
    label: 'E-mail',
    component: 'REVIEW',
    item_key: 'email',
    value: ''
  }
]

export let certificateSpecs = [
  {
    label: 'Certificate number',
    item_key: 'certificateNumber',
    value: '',
    sort_key: 'certificate_number'
  },
  {
    label: 'Certificate number',
    item_key: 'certificateLink',
    value: {
      url: { name: 'ReportsUpcomingView', params: { certificateId: '' } }
    },
    title_key: 'certificateNumber',
    component: 'LinkComponent',
    sort_key: 'certificate_number'
  },
  {
    label: 'Certificate number',
    item_key: 'certificateAdminLink',
    value: {
      url: { name: 'CertificateDetailView', params: { certificateId: '' } }
    },
    title_key: 'certificateNumber',
    component: 'LinkComponent',
    sort_key: 'certificate_number'
  },
  {
    label: 'Certificate number',
    item_key: 'certificateViewLink',
    value: {
      url: { name: 'CertificateDetailView', params: { certificateId: '' } }
    },
    title_key: 'certificateNumber',
    component: 'LinkComponent',
    sort_key: 'certificate_number'
  },
  {
    label: 'Issue date',
    item_key: 'issueDate',
    value: '',
    sort_key: 'issued_date',
    filter: 'date_issued'
  },
  {
    label: 'Validity period',
    item_key: 'validityPeriod',
    value: ''
  },
  {
    label: 'State',
    item_key: 'state',
    value: { display: '', level: 0 },
    component: 'StatusComponent',
    filter: 'state',
    sort_key: 'state'
  },
  {
    label: 'Expiry date',
    item_key: 'expiryDate',
    value: '',
    sort_key: 'expiry_date',
    filter: 'date_expired'
  },
  {
    label: 'Customer name',
    item_key: 'customer.fullName',
    value: '',
    sort_key: 'first_name,last_name'
  },
  {
    label: 'Email',
    item_key: 'customer.email',
    value: ''
  },
  {
    label: 'Certification',
    item_key: 'service.code',
    value: '',
    filter: 'service',
    sort_key: 'service_code'
  },
  {
    label: 'Certification',
    item_key: 'service.shortName',
    value: '',
    sort_key: 'service_code',
    filter: 'service'
  },
  {
    label: 'Certification',
    item_key: 'service.name',
    value: '',
    filter: 'service',
    sort_key: 'service_name'
  },
  {
    label: 'Qualification',
    item_key: 'qualification.value',
    value: ''
  },
  {
    label: 'Qualification',
    item_key: 'qualification.display',
    value: ''
  },
  {
    label: 'Holder',
    item_key: 'holder',
    value: '',
    sort_key: 'first_name,last_name'
  },
  {
    label: 'Holder',
    item_key: 'customer.fullName',
    value: '',
    sort_key: 'first_name,last_name'
  },
  {
    label: 'Mobile',
    item_key: 'customer.mobileNumber',
    value: ''
  },
  {
    label: 'Phone',
    item_key: 'customer.phoneNumber',
    value: ''
  },
  {
    label: 'Postal address',
    item_key: 'customer.postalAddress',
    value: ''
  },
  {
    label: 'Postal city',
    item_key: 'customer.city',
    value: ''
  },
  {
    label: 'Company',
    item_key: 'customer.invoiceCustomerName',
    value: ''
  },
  {
    label: 'Is Reported',
    item_key: 'isReported',
    value: { display: '', level: 0 },
    component: 'StatusComponent',
    sort_key: 'is_reported',
    filter: 'is_reported'
  },
  {
    label: 'Is Reported',
    item_key: 'isReportedCell',
    value: { display: '', level: 0 },
    component: 'StatusCellComponent',
    sort_key: 'is_reported'
  },
  {
    label: 'Last report state',
    item_key: 'caseReportState',
    component: 'StatusComponent',
    value: { display: '', level: 0 }
  },
  {
    label: 'Suspension date',
    item_key: 'suspensionDate',
    value: '',
    sort_key: 'suspension_date',
    filter: 'suspension_date'
  },
  {
    label: 'Suspension end date',
    item_key: 'suspensionExpiryDate',
    value: '',
    sort_key: 'suspension_expiry_date',
    filter: 'suspension_expiry_date'
  },
  {
    label: 'Customer person number',
    item_key: 'customer.personNumber',
    value: '',
    sort_key: 'person_number'
  },
  {
    label: 'Invoice customer',
    item_key: 'customer.invoiceCustomerName',
    value: '',
    sort_key: 'invoice_customer'
  },
  {
    label: 'Organisation name',
    item_key: 'customer.organisationName',
    value: '',
    sort_key: 'organisation'
  },
  {
    label: 'Organisation name',
    item_key: 'customer.organisationLink',
    value: '',
    // This is weird, but we can't span through classes here, we have a getter in Certificate.js
    title_key: 'organisationName',
    component: 'LinkComponent',
    sort_key: 'organisation'
  },
  {
    label: 'Remove',
    item_key: 'self',
    value: {},
    component: 'DisconnectCustomerComponent'
  },
  {
    label: 'County',
    item_key: 'customer.county',
    value: '',
    filter: 'customer.county'
  },
  {
    label: 'Reported hours',
    item_key: 'reportData.totalNumberReportedHours',
    value: ''
  },
  {
    label: 'Reported simple projects',
    item_key: 'reportData.totalNumberReportedSimpleProjects',
    value: ''
  },
  {
    label: 'Reported complex projects',
    item_key: 'reportData.totalNumberReportedComplexProjects',
    value: ''
  }
]

export let certificateReportSpecs = [
  {
    label: 'Period',
    item_key: 'periodDate',
    value: ''
  },
  {
    label: 'Reported at',
    item_key: 'reportDate',
    value: ''
  },
  {
    label: 'Documents',
    item_key: 'filesComponent',
    value: [],
    component: 'FilesComponent'
  },
  {
    label: 'User',
    item_key: 'user',
    value: ''
  },
  {
    label: 'Comment',
    item_key: 'reportComment',
    value: ''
  },
  {
    label: 'Blank reason',
    item_key: 'reportBlankReason',
    value: ''
  },
  {
    label: 'Comment',
    item_key: 'self',
    value: {},
    component: 'ReportsCommentComponent'
  },
  {
    label: 'Case id',
    item_key: 'caseId',
    value: {}
  },
  {
    label: 'Case',
    item_key: 'caseLink',
    value: {},
    title_key: 'caseId',
    component: 'LinkGridComponent'
  }
]

export let serviceSpecs = [
  {
    label: 'Name',
    item_key: 'name',
    value: '',
    width: '20%'
  },
  {
    label: 'Description',
    item_key: 'description',
    value: '',
    width: '50%'
  },
  {
    label: 'Qualification',
    item_key: 'appliedQualificationsStr',
    value: '',
    width: '15%'
  },
  {
    label: 'Qualification',
    item_key: 'availableQualificationsStr',
    value: '',
    width: '15%'
  },
  {
    label: 'Applied date',
    item_key: 'created',
    value: '',
    width: '15%',
    classes: 'has-text-right'
  },
  {
    item_key: 'button',
    value: { text: '', clickHandler: () => {} },
    component: 'ButtonComponent',
    width: '15%'
  }
]

export let smsLogSpecs = [
  {
    label: 'Sent date',
    item_key: 'created',
    value: ''
  },
  {
    label: 'To',
    item_key: 'receiver',
    value: ''
  },
  {
    label: 'From',
    item_key: 'sender',
    value: ''
  },
  {
    label: 'Message',
    item_key: 'message',
    value: ''
  },
  {
    label: 'Status',
    item_key: 'statusResult',
    value: { display: '', level: 0 },
    component: 'StatusComponent'
  }
]

export let messageSpecs = [
  {
    label: 'To',
    item_key: 'receiver',
    value: ''
  },
  {
    label: 'From',
    item_key: 'sender',
    value: ''
  },
  {
    label: 'Subject',
    item_key: 'subject',
    value: ''
  },
  {
    label: 'Message',
    item_key: 'content',
    value: ''
  },
  {
    label: 'Sent',
    item_key: 'date',
    value: ''
  },
  {
    label: 'Documents',
    item_key: 'filesComponent',
    value: [],
    component: 'FilesComponent'
  }
]
